<div #mainDiv_ll_model_collateral_edit_model>
  <div *ngIf="bundle.showDisplay"
       [style.top.px]="bundle.panelY"
       [style.left.px]="bundle.panelX"
       style="position: absolute;">

    <jqxPanel [autoUpdate]="true"
              [width]="bundle.panelW"
              [height]="bundle.panelH"
              style="background-color: transparent; border: none; border-bottom: 2px solid rgb(160, 158, 158);">

      <div class="form-container">

        <div class="form-row">
          <label class="form-label">Loan Commitment:</label>
          <div style="display: flex; align-items: center; gap: 12px; flex: 1;">
            <input type="text"
                   [ngModel]="formattedCommitmentAmt"
                   (input)="updateCommitmentAmt($event)"
                   class="form-input loan-commitment-input"
                   placeholder="e.g. 1,250,000"
                   style="flex: none;" />
            <span *ngIf="hasCommitmentChanged"
                  class="wordBtn_12"
                  (click)="saveCommitmentChange()">
              Save Change
            </span>
          </div>
        </div>

        <div class="form-row">
          <label class="form-label">Collateral Type:</label>
          <select [ngModel]="collateralType"
                  (ngModelChange)="onChanged('LIMIT_COLLATERAL_TYPE', $event)"
                  class="form-input form-select">
            <option value="" disabled *ngIf="!collateralType">
              Select collateral type...
            </option>
            <option *ngFor="let opt of collateralTypeOptions"
                    [value]="opt.value">
              {{ opt.label }}
            </option>
          </select>
        </div>

        <div class="form-row">
          <label class="form-label">Age Cap Calculation Level:</label>

          <select [ngModel]="ageCapCalcLevel"
                  (ngModelChange)="onChanged('LIMIT_AGECAP_CALCLEVEL', $event)"
                  class="form-input form-select">
            <option value="" disabled *ngIf="!ageCapCalcLevel">
              Select ...
            </option>
            <option *ngFor="let opt of calcLevelOptions"
                    [value]="opt.value">
              {{ opt.label }}
            </option>
          </select>
        </div>

        <div class="form-row">
          <label class="form-label">Calculation Sequence:</label>
          <select [ngModel]="calcSequence"
                  (ngModelChange)="onChanged('LIMIT_CALCSEQUENCE', $event)"
                  class="form-input form-select">
            <option value="" disabled *ngIf="!calcSequence">
              Select collateral type...
            </option>
            <option *ngFor="let opt of calcSequenceOptions"
                    [value]="opt.value">
              {{ opt.label }}
            </option>
          </select>
        </div>

        <div class="form-row" *ngIf="showTrueUpBbcField">
          <label class="form-label">Display Using Standard Classes:</label>
          <div class="true-up-container"
               style="flex: 1; display: flex; align-items: center; gap: 24px; white-space: nowrap;">
            <div class="radio-group"
                 style="display: flex; align-items: center; gap: 28px; flex-shrink: 0; padding-right: 2px;">
              <label style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
                <input type="radio"
                       name="customClassBBCYesNo"
                       [value]="'Yes'"
                       [checked]="customClassBBCYesNo === 'Yes'"
                       (change)="onChanged('CUSTOMCLASSBBCYESNO', 'Yes')" />
                Yes
              </label>
              <label style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
                <input type="radio"
                       name="customClassBBCYesNo"
                       [value]="'No'"
                       [checked]="customClassBBCYesNo === 'No'"
                       (change)="onChanged('CUSTOMCLASSBBCYESNO', 'No')" />
                No
              </label>
            </div>
          </div>
        </div>

        <div class="form-row" *ngIf="showTrueUpBbcField">
          <label class="form-label">Include Roll Forward:</label>
          <div class="true-up-container"
               style="flex: 1; display: flex; align-items: center; gap: 24px; white-space: nowrap;">
            <div class="radio-group"
                 style="display: flex; align-items: center; gap: 28px; flex-shrink: 0; padding-right: 2px;">
              <label style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
                <input type="radio"
                       name="trueUpBbcYesNo"
                       [value]="'Yes'"
                       [checked]="trueUpBbcYesNo === 'Yes'"
                       (change)="onChanged('LIMIT_TRUEUPBBCYESNO', 'Yes')" />
                Yes
              </label>
              <label style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
                <input type="radio"
                       name="trueUpBbcYesNo"
                       [value]="'No'"
                       [checked]="trueUpBbcYesNo === 'No'"
                       (change)="onChanged('LIMIT_TRUEUPBBCYESNO', 'No')" />
                No
              </label>
            </div>


          </div>
        </div>

        <div class="form-row" *ngIf="trueUpBbcYesNo === 'Yes'">
          <label class="form-label">Roll Forward - BBC Location:</label>

          <select [ngModel]="trueUpBBCLocation"
                  (ngModelChange)="onChanged('LIMIT_TRUEUPBBCLOCATION', $event)"
                  class="form-input form-select">
            <option value="" disabled *ngIf="!bbcLocationOptions">
              Select ...
            </option>
            <option *ngFor="let opt of bbcLocationOptions"
                    [value]="opt.value">
              {{ opt.label }}
            </option>
          </select>
        </div>

        <div class="form-row" *ngIf="trueUpBbcYesNo === 'Yes'">
          <label class="form-label">Roll Forward Type:</label>
          <div style="display: flex; align-items: center; gap: 32px; white-space: nowrap;">
            <select [ngModel]="trueUpType"
                    (ngModelChange)="onChanged('LIMIT_TRUEUPTYPE', $event)"
                    class="form-input form-select">
              <option value="" disabled *ngIf="!trueUpType">
                Select collateral type...
              </option>
              <option *ngFor="let opt of trueUpTypeOptions"
                      [value]="opt.value">
                {{ opt.label }}
              </option>
            </select>

            <label class="form-label" style="width: auto; text-align: right; padding-left: 15px; padding-right: 63px;">
              Ineligible Payers:
            </label>
            <select [ngModel]="trueUpIneligiblePayerType"
                    (ngModelChange)="onChanged('LIMIT_TRUEUPINELIGIBLEPAYERTYPE', $event)"
                    class="form-input form-select">
              <option value="" disabled *ngIf="!trueUpIneligiblePayerType">
                Select...
              </option>
              <option *ngFor="let opt of trueUpIneligiblePayerTypeOptions"
                      [value]="opt.value">
                {{ opt.label }}
              </option>
            </select>

            <!--<label class="form-label" style="width: 125px; text-align: right; padding-right: 8px;">
        Include Ineligible Payers:
      </label>
      <div class="radio-group"
           style="display: flex; align-items: center; gap: 28px; flex-shrink: 0; margin-left: 10px;">
        <label style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
          <input type="radio"
                 name="trueUpIneligiblePayersYesNo"
                 [value]="'Yes'"
                 [checked]="trueUpIneligiblePayersYesNo === 'Yes'"
                 (change)="onChanged('LIMIT_TRUEUPINELIGIBLEPAYERSYESNO', 'Yes')" />
          Yes
        </label>
        <label style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
          <input type="radio"
                 name="trueUpIneligiblePayersYesNo"
                 [value]="'No'"
                 [checked]="trueUpIneligiblePayersYesNo === 'No'"
                 (change)="onChanged('LIMIT_TRUEUPINELIGIBLEPAYERSYESNO', 'No')" />
          No
        </label>
      </div>-->
          </div>
        </div>

        <div class="form-row" *ngIf="trueUpBbcYesNo === 'Yes' && trueUpType === 'PaymentsPosted'">
          <label class="form-label">Roll Forward - Start When:</label>

          <select [ngModel]="trueUpStartWhen"
                  (ngModelChange)="onChanged('LIMIT_TRUEUPSTARTWHEN', $event)"
                  class="form-input form-select">
            <option value="" disabled *ngIf="!trueUpStartWhen">
              Select ...
            </option>
            <option *ngFor="let opt of trueUpStartWhenOptions"
                    [value]="opt.value">
              {{ opt.label }}
            </option>
          </select>
        </div>

        <!--Unposted Payments-->
        <div class="form-row">
          <label class="form-label">Include Unposted Payments:</label>
          <div class="true-up-container"
               style="flex: 1; display: flex; align-items: center; gap: 24px; white-space: nowrap;">
            <div class="radio-group"
                 style="display: flex; align-items: center; gap: 28px; flex-shrink: 0;padding-right: 2px;">
              <label style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
                <input type="radio"
                       name="unpostedIncludeYesNo"
                       [value]="'Yes'"
                       [checked]="unpostedIncludeYesNo === 'Yes'"
                       (change)="onChanged('LIMIT_UNPOSTED_INCLUDEYESNO', 'Yes')" />
                Yes
              </label>
              <label style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
                <input type="radio"
                       name="unpostedIncludeYesNo"
                       [value]="'No'"
                       [checked]="unpostedIncludeYesNo === 'No'"
                       (change)="onChanged('LIMIT_UNPOSTED_INCLUDEYESNO', 'No')" />
                No
              </label>
            </div>
          </div>
        </div>

        <div class="form-row" *ngIf="unpostedIncludeYesNo === 'Yes'">
          <label class="form-label">Unposted Payments - Start When:</label>

          <select [ngModel]="unpostedStartWhen"
                  (ngModelChange)="onChanged('LIMIT_UNPOSTED_STARTWHEN', $event)"
                  class="form-input form-select">
            <option value="" disabled *ngIf="!unpostedStartWhen">
              Select ...
            </option>
            <option *ngFor="let opt of unpostedStartWhenOptions"
                    [value]="opt.value">
              {{ opt.label }}
            </option>
          </select>
        </div>

        <div class="form-row" *ngIf="currentEarnedYesNo === 'Yes'">
          <label class="form-label">Unposted Payments-Location:</label>

          <select [ngModel]="unpostedBbcLocation"
                  (ngModelChange)="onChanged('LIMIT_UNPOSTED_BBCLOCATION', $event)"
                  class="form-input form-select">
            <option value="" disabled *ngIf="!unpostedBbcLocation">
              Select ...
            </option>
            <option *ngFor="let opt of bbcLocationOptions"
                    [value]="opt.value">
              {{ opt.label }}
            </option>
          </select>
        </div>

        <div class="form-row" *ngIf="unpostedIncludeYesNo === 'Yes'">
          <label class="form-label">Unposted Payments - Eligibility Period:</label>
          <div style="display: flex; align-items: center; gap: 32px; white-space: nowrap;">
            <select [ngModel]="unpostedAgeCapDays"
                    (ngModelChange)="onChanged('LIMIT_UNPOSTED_AGECAPDAYS', $event)"
                    class="form-input form-select">
              <option value="" disabled *ngIf="!unpostedAgeCapDays">
                Select...
              </option>
              <option *ngFor="let days of ageCapOptions"
                      [value]="days">
                {{ days }} days
              </option>
            </select>

            <label class="form-label" style="width: 120px; text-align: right; padding-right: 8px;">
              Include Ineligible Payers:
            </label>
            <div class="radio-group"
                 style="display: flex; align-items: center; gap: 28px; flex-shrink: 0; margin-left: 10px;">
              <label style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
                <input type="radio"
                       name="unpostedIneligiblePayersYesNo"
                       [value]="'Yes'"
                       [checked]="unpostedIneligiblePayersYesNo === 'Yes'"
                       (change)="onChanged('LIMIT_UNPOSTED_INELIGIBLEPAYERSYESNO', 'Yes')" />
                Yes
              </label>
              <label style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
                <input type="radio"
                       name="unpostedIneligiblePayersYesNo"
                       [value]="'No'"
                       [checked]="unpostedIneligiblePayersYesNo === 'No'"
                       (change)="onChanged('LIMIT_UNPOSTED_INELIGIBLEPAYERSYESNO', 'No')" />
                No
              </label>
            </div>
          </div>
        </div>

        <!--Current AR-->
        <div class="form-row">
          <label class="form-label">Earn in Unbilled AR:</label>
          <div class="true-up-container"
               style="flex: 1; display: flex; align-items: center; gap: 24px; white-space: nowrap;">
            <div class="radio-group"
                 style="display: flex; align-items: center; gap: 28px; flex-shrink: 0; padding-right: 2px;">
              <label style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
                <input type="radio"
                       name="currentEarnedYesNo"
                       [value]="'Yes'"
                       [checked]="currentEarnedYesNo === 'Yes'"
                       (change)="onChanged('LIMIT_CURRENTEARNEDYESNO', 'Yes')" />
                Yes
              </label>
              <label style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
                <input type="radio"
                       name="currentEarnedYesNo"
                       [value]="'No'"
                       [checked]="currentEarnedYesNo === 'No'"
                       (change)="onChanged('LIMIT_CURRENTEARNEDYESNO', 'No')" />
                No
              </label>
            </div>

          </div>
        </div>

        <div class="form-row" *ngIf="currentEarnedYesNo === 'Yes'">
          <label class="form-label">Earn Unbilled-Location:</label>

          <select [ngModel]="currentBbcLocation"
                  (ngModelChange)="onChanged('LIMIT_CURRENT_BBCLOCATION', $event)"
                  class="form-input form-select">
            <option value="" disabled *ngIf="!currentBbcLocation">
              Select ...
            </option>
            <option *ngFor="let opt of bbcLocationOptions"
                    [value]="opt.value">
              {{ opt.label }}
            </option>
          </select>
        </div>

        <div class="form-row" *ngIf="currentEarnedYesNo === 'No'">
          <label class="form-label">Include Unbilled AR:</label>
          <div class="true-up-container"
               style="flex: 1; display: flex; align-items: center; gap: 24px; white-space: nowrap;">
            <div class="radio-group"
                 style="display: flex; align-items: center; gap: 28px; flex-shrink: 0;">
              <label style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
                <input type="radio"
                       name="currentIncludedYesNo"
                       [value]="'Yes'"
                       [checked]="currentIncludedYesNo === 'Yes'"
                       (change)="onChanged('LIMIT_CURRENTINCLUDEDYESNO', 'Yes')" />
                Yes
              </label>
              <label style="display: flex; align-items: center; gap: 6px; cursor: pointer;">

                <input type="radio"
                       name="currentIncludedYesNo"
                       [value]="'No'"
                       [checked]="currentIncludedYesNo === 'No'"
                       (change)="onChanged('LIMIT_CURRENTINCLUDEDYESNO', 'No')" />
                No
              </label>
            </div>
          </div>
        </div>

        <div class="form-row" *ngIf="collateralType != 'Close' && currentIncludedYesNo === 'Yes' && currentEarnedYesNo === 'No'">
          <label class="form-label">Days to Bill in New Month:</label>
          <div style="display: flex; align-items: center; gap: 32px; white-space: nowrap;">
            <select [ngModel]="daysToBill"
                    (ngModelChange)="onChanged('LIMIT_DAYSTOBILL', $event)"
                    class="form-input form-select">
              <option value="" disabled *ngIf="!daysToBill">
                Select...
              </option>
              <option *ngFor="let days of daysToBillOptions"
                      [value]="days">
                {{ days }} days
              </option>
            </select>
          </div>
        </div>



        <div class="form-row" *ngIf="envDynamicYesNo === 'Yes'">
          <label class="form-label">Dynamic ENV Allowed Lower Percent:</label>
          <select [ngModel]="envLowerRange"
                  (ngModelChange)="onChanged('LIMIT_ENV_LOWERRANGE', $event)"
                  class="form-input form-select">
            <option value="" disabled *ngIf="!envLowerRange">
              Select...
            </option>
            <option *ngFor="let range of envLowerRangeOptions"
                    [value]="range">
              {{ range }} %
            </option>
          </select>
          <label class="form-label" style="width: auto; text-align: right; padding-left: 15px; padding-right: 63px;">
            Upper Percent:
          </label>
          <select [ngModel]="envUpperRange"
                  (ngModelChange)="onChanged('LIMIT_ENV_UPPERRANGE', $event)"
                  class="form-input form-select">
            <option value="" disabled *ngIf="!envUpperRange">
              Select...
            </option>
            <option *ngFor="let range of envUpperRangeOptions"
                    [value]="range">
              {{ range }} %
            </option>
          </select>
        </div>





        <div class="form-row">
          <label class="form-label">Neg Acct. Balances (Credits):</label>
          <div class="radio-group"
               style="display: flex; align-items: center; gap: 28px; flex-shrink: 0; padding-right: 25px;">
            <label style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
              <input type="radio"
                     name="creditsYesNo"
                     [value]="'Yes'"
                     [checked]="creditsYesNo === 'Yes'"
                     (change)="onChanged('LIMIT_CREDITS_YESNO', 'Yes')" />
              Yes
            </label>
            <label style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
              <input type="radio"
                     name="creditsYesNo"
                     [value]="'No'"
                     [checked]="creditsYesNo === 'No'"
                     (change)="onChanged('LIMIT_CREDITS_YESNO', 'No')" />
              No
            </label>
          </div>

          <div *ngIf="creditsYesNo === 'Yes'"
               style="display: flex; align-items: center; gap: 12px; margin-left: 32px;">
            <label class="form-label" style="width: auto; text-align: right; padding-right: 8px;">
              Days:
            </label>
            <select [ngModel]="creditsDays"
                    (ngModelChange)="onChanged('LIMIT_CREDITS_DAYS', $event)"
                    class="form-input form-select cross-age-days">
              <option value="" disabled *ngIf="!creditsDays">
                Select...
              </option>
              <option *ngFor="let days of ageCapOptions"
                      [value]="days">
                {{ days }} days
              </option>
            </select>

          </div>
        </div>

        <div class="form-row" *ngIf="creditsYesNo === 'Yes'">
          <label class="form-label">Credits Calculation Level:</label>

          <select [ngModel]="creditsCalcLevel"
                  (ngModelChange)="onChanged('LIMIT_CREDIT_CALCLEVEL', $event)"
                  class="form-input form-select">
            <option value="" disabled *ngIf="!creditsCalcLevel">
              Select ...
            </option>
            <option *ngFor="let opt of calcLevelOptions"
                    [value]="opt.value">
              {{ opt.label }}
            </option>
          </select>
        </div>

        <div class="form-row">
          <label class="form-label">Payer Cap:</label>
          <div class="radio-group"
               style="display: flex; align-items: center; gap: 28px; flex-shrink: 0; padding-right: 25px;">
            <label style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
              <input type="radio"
                     name="payerCapYesNo"
                     [value]="'Yes'"
                     [checked]="payerCapYesNo === 'Yes'"
                     (change)="onChanged('LIMIT_PAYERCAP_YESNO', 'Yes')" />
              Yes
            </label>
            <label style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
              <input type="radio"
                     name="payerCapYesNo"
                     [value]="'No'"
                     [checked]="payerCapYesNo === 'No'"
                     (change)="onChanged('LIMIT_PAYERCAP_YESNO', 'No')" />
              No
            </label>
          </div>
          <div *ngIf="payerCapYesNo === 'Yes'"
               style="display: flex; align-items: center; gap: 12px; margin-left: 32px;">

            <label class="form-label" style="width: auto; text-align: right; padding-right: 8px; margin-left: 0px;">
              Percent:
            </label>
            <select [ngModel]="payerCapPct"
                    (ngModelChange)="onChanged('LIMIT_PAYERCAP_PCT', $event)"
                    class="form-input form-select cross-age-pct">
              <option value="" disabled *ngIf="!payerCapPct">
                Select...
              </option>
              <option *ngFor="let pct of crossAgePctOptions"
                      [value]="pct">
                {{ pct }} %
              </option>
            </select>
          </div>
        </div>

        <!--<div class="form-row" *ngIf="unpostedIncludeYesNo === 'Yes'">
    <label class="form-label">Display:</label>

    <select [ngModel]="unpostedStartWhen"
            (ngModelChange)="onChanged('LIMIT_UNPOSTED_STARTWHEN', $event)"
            class="form-input form-select">
      <option value="" disabled *ngIf="!unpostedStartWhen">
        Select ...
      </option>
      <option *ngFor="let opt of unpostedStartWhenOptions"
              [value]="opt.value">
        {{ opt.label }}
      </option>
    </select>
  </div>-->

        <div class="form-row">
          <label class="form-label">Age Cap (Ineligible Over Days) - Billed:</label>
          <div style="display: flex; align-items: center; gap: 32px; white-space: nowrap;">

            <label class="form-label">Set At Payer Type/Class and or Payer (Plan) level:</label>

            <!--<select [ngModel]="billedAgeCapDays"
              (ngModelChange)="onChanged('LIMIT_BILLED_AGECAPDAYS', $event)"
              class="form-input form-select">
        <option value="" disabled *ngIf="!billedAgeCapDays">Select...</option>
        <option *ngFor="let days of ageCapOptions" [value]="days">
          {{ days }} days
        </option>
      </select>-->
          </div>
        </div>






        <div class="form-row">
          <label class="form-label">Advance Percent - Billed and Unbilled:</label>
          <div style="display: flex; align-items: center; gap: 32px; white-space: nowrap;">

            <label class="form-label">Set At Payer Type/Class and or Payer (Plan) level:</label>

            <!--<select [ngModel]="billedAdvancePct"
              (ngModelChange)="onChanged('LIMIT_BILLEDADVANCE_PCT', $event)"
              class="form-input form-select">
        <option value="" disabled *ngIf="!billedAdvancePct">
          Select...
        </option>
        <option *ngFor="let pct of crossAgePctOptions"
                [value]="pct">
          {{ pct }} %
        </option>
      </select>-->
            <!--<div *ngIf="currentIncludedYesNo === 'Yes'"
           style="display: flex; align-items: center; gap: 12px;">
        <label class="form-label" style="width: auto; text-align: right; padding-right: 8px;">
          Unbilled (Current Period):
        </label>
        <select [ngModel]="unbilledAdvancePct"
                (ngModelChange)="onChanged('LIMIT_UNBILLEDADVANCE_PCT', $event)"
                class="form-input form-select">
          <option value="" disabled *ngIf="!unbilledAdvancePct">
            Select...
          </option>
          <option *ngFor="let pct of crossAgePctOptions"
                  [value]="pct">
            {{ pct }} %
          </option>
        </select>
      </div>-->
          </div>
        </div>

        <div class="form-row">
          <label class="form-label">Dynamic Liquidity/ENV Percent:</label>

          <label class="form-label">Set At Payer Type/Class and or Payer (Plan) level:</label>

          <!--<div class="radio-group"
         style="display: flex; align-items: center; gap: 28px; flex-shrink: 0;">
      <label style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
        <input type="radio"
               name="envDynamicYesNo"
               [value]="'Yes'"
               [checked]="envDynamicYesNo === 'Yes'"
               (change)="onChanged('LIMIT_ENV_DYNAMICYESNO', 'Yes')" />
        Yes
      </label>
      <label style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
        <input type="radio"
               name="envDynamicYesNo"
               [value]="'No'"
               [checked]="envDynamicYesNo === 'No'"
               (change)="onChanged('LIMIT_ENV_DYNAMICYESNO', 'No')" />
        No
      </label>
    </div>-->
          <!--<div *ngIf="envDynamicYesNo === 'No'"
         style="display: flex; align-items: center; gap: 12px; margin-left: 55px;">
      <label class="form-label" style="width: auto; text-align: right; padding-right: 52px;">
        Override Percent:
      </label>
      <select [ngModel]="envOverridePct"
              (ngModelChange)="onChanged('LIMIT_ENV_OVERRIDE_PCT', $event)"
              class="form-input form-select">
        <option value="" disabled *ngIf="!envOverridePct">
          Select...
        </option>
        <option *ngFor="let pct of crossAgePctOptions"
                [value]="pct">
          {{ pct }} %
        </option>
      </select>
    </div>-->
          <!--<div *ngIf="envDynamicYesNo === 'Yes'"
         style="display: flex; align-items: center; gap: 12px; margin-left: 55px;">
      <label class="form-label" style="width: auto; text-align: right; padding-right: 30px;">
        ENV pct. Calc Period:
      </label>
      <select [ngModel]="envCalcPeriodDays"
              (ngModelChange)="onChanged('LIMIT_ENV_CALCPERIOD_DAYS', $event)"
              class="form-input form-select">
        <option value="" disabled *ngIf="!envCalcPeriodDays">
          Select...
        </option>
        <option *ngFor="let days of ageCapOptions"
                [value]="days">
          {{ days }} Period
        </option>
      </select>
    </div>-->
        </div>



        <div class="form-row">
          <label class="form-label">Cross Age:</label>

          <!--<label class="form-label">Set At Payer Type/Class and or Payer (Plan) level:</label>-->

          <div class="radio-group"
               style="display: flex; align-items: center; gap: 28px; flex-shrink: 0; padding-right: 25px;">
            <label style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
              <input type="radio"
                     name="crossAgeYesNo"
                     [value]="'Yes'"
                     [checked]="crossAgeYesNo === 'Yes'"
                     (change)="onChanged('LIMIT_CROSSAGE_YESNO', 'Yes')" />
              Yes
            </label>
            <label style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
              <input type="radio"
                     name="crossAgeYesNo"
                     [value]="'No'"
                     [checked]="crossAgeYesNo === 'No'"
                     (change)="onChanged('LIMIT_CROSSAGE_YESNO', 'No')" />
              No
            </label>
          </div>





          <!--<div *ngIf="crossAgeYesNo === 'Yes'"
         style="display: flex; align-items: center; gap: 12px; margin-left: 32px;">
      <label class="form-label" style="width: auto; text-align: right; padding-right: 8px;">
        Days:
      </label>
      <select [ngModel]="crossAgeDays"
              (ngModelChange)="onChanged('LIMIT_CROSSAGE_DAYS', $event)"
              class="form-input form-select cross-age-days">
        <option value="" disabled *ngIf="!crossAgeDays">
          Select...
        </option>
        <option *ngFor="let days of ageCapOptions"
                [value]="days">
          {{ days }} days
        </option>
      </select>

      <label class="form-label" style="width: auto; text-align: right; padding-right: 8px; margin-left: 16px;">
        Percent:
      </label>
      <select [ngModel]="crossAgePct"
              (ngModelChange)="onChanged('LIMIT_CROSSAGE_PCT', $event)"
              class="form-input form-select cross-age-pct">
        <option value="" disabled *ngIf="!crossAgePct">
          Select...
        </option>
        <option *ngFor="let pct of crossAgePctOptions"
                [value]="pct">
          {{ pct }} %
        </option>
      </select>
    </div>-->
        </div>

        <div class="form-row" *ngIf="crossAgeYesNo === 'Yes'">
          <label class="form-label">Cross Age Calculation Level:</label>

          <select [ngModel]="crossAgeCalcLevel"
                  (ngModelChange)="onChanged('LIMIT_CROSSAGE_CALCLEVEL', $event)"
                  class="form-input form-select">
            <option value="" disabled *ngIf="!crossAgeCalcLevel">
              Select ...
            </option>
            <option *ngFor="let opt of calcLevelOptions"
                    [value]="opt.value">
              {{ opt.label }}
            </option>
          </select>
        </div>


      </div>
</jqxPanel>
  </div>
</div>
